import clsx from 'clsx'
import { CtaBannerBlock } from '@/src/@types/statamic'
import Bard from '@/src/components/bard/Bard'
import Picture from '@/src/components/elements/Picture'
import { Block } from '@/src/lib/PageBuilder'

export default function Component({
  image,
  cta_banner_content,
  blocks,
  index,
}: CtaBannerBlock & {
  blocks: Block[]
  index: number
}) {
  const removeTopMargin = blocks[index - 1]?.block === 'testimonials'

  return (
    <div
      className={clsx({
        '-mt-20 lg:-mt-24': removeTopMargin,
      })}
    >
      <div className="relative">
        <div
          className="absolute inset-y-0 left-0 -z-10 hidden bg-gradient-700 md:block"
          style={{
            right:
              'calc(max(0px, (100% - 1328px) / 2) + min((1328px + 24px) / 3, 100% / 3))',
          }}
        />
        <div
          className="absolute inset-y-0 right-0 hidden md:block"
          style={{
            left: 'calc(max(0px, (100% - 1328px) / 2) + min((1328px - 12px) / 3 * 2, 100% / 3 * 2))',
          }}
        >
          <Picture {...image} fill className="object-cover" />
        </div>
        <div className="mx-auto grid grid-cols-1 md:grid-cols-3 md:bg-none md:px-6 lg:max-w-container">
          <div className="col-span-1 bg-gradient-700 px-5 pt-12 pb-8 text-center md:col-span-2 md:p-0 md:py-31 md:pr-30 md:text-left">
            <Bard
              content={cta_banner_content}
              textColor="white"
              align="mobileCenter"
              fullWidth
            />
          </div>
          <div className="aspect-w-[1.2] relative aspect-h-1 md:hidden">
            <Picture {...image} fill className="object-cover" />
          </div>
        </div>
      </div>
    </div>
  )
}
